<template>
    <v-dialog v-if="!loading" v-model="dialog">
        <v-card>
            <v-card-actions>
                <v-icon color="error" @click="closeDialog()">mdi-close</v-icon>
            </v-card-actions>
            <v-card-text>
                <v-row>
                    <v-col class="text-center" cols="12" v-if="type === 'image'">
                        <img class="file-image" :src="url" height="70%" alt="image">
                    </v-col>
                    <v-col class="text-center" cols="12" v-if="type === 'video'">
                        <video-player source="ShowFileComponent" :options="videoOptions"></video-player>
                    </v-col>
                    <v-col class="text-center" cols="12" v-if="type === 'audio'">
                        <audio :src="url" controls style="width: 100%"></audio>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import VideoPlayer from "@/components/Player/VideoPlayer";

export default {
    name: "ShowFileComponent",
    components: {VideoPlayer},
    props: ['type', 'url'],
    data() {
        return {
            loading: true,
            dialog: false,
            videoOptions: {
                autoplay: true,
                playbackRates: [0.5, 1, 1.5, 2, 4, 8],
                height: 500,
                width: 888,
                controls: true,
                liveui: true,
                responsive: true,
                sources: [
                    {
                        src: '',
                        type: "application/vnd.apple.mpegurl"
                    }
                ],
            },
        }
    },
    methods: {
        closeDialog() {
            this.dialog = false
        }
    },
    watch: {
        type(value) {
            if (value === 'video') {
                this.videoOptions.sources[0].src = this.url
                this.loading = false
            } else {
                this.loading = false
            }
        }
    },
    mounted() {

    }
}
</script>

<style>
.file-image {
    aspect-ratio: 1 !important;
    object-fit: cover !important;
}
</style>